import { render, staticRenderFns } from "./ProgramadorSeleccioneDocente.vue?vue&type=template&id=3a23dbbe&"
import script from "./ProgramadorSeleccioneDocente.vue?vue&type=script&lang=js&"
export * from "./ProgramadorSeleccioneDocente.vue?vue&type=script&lang=js&"
import style0 from "./ProgramadorSeleccioneDocente.vue?vue&type=style&index=0&id=3a23dbbe&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports